<template>
    <v-toolbar :color="color" dark :flat="transparent" style="flex: 0 1 64px;">

        <div @click="goHome" style="cursor:pointer">
            <img class="largeLogo" src="images/logo.png">
            <img class="smallLogo" src="images/logosmall.png">
        </div>

        <v-spacer></v-spacer>

        <v-btn v-if="false" round color="primary" class="white--text" @click="refer">{{$t("Refer new users")}}</v-btn>
        <v-chip v-if="$user" round color="primary" class="white--text" @click="goReferral">{{$t("Get More Credits!")}}</v-chip>

        <StaminaIndicator v-if="$user"></StaminaIndicator>

        <v-chip v-if="!$user && registerAd" round color="primary" class="white--text" @click="goRegister">{{$t("Register and get free Credits!")}}</v-chip>
        <v-btn v-if="!$user" fab light small @click="goLogin">
            <v-icon size="24">person</v-icon>
        </v-btn>

        <v-menu v-if="$user" transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on }">
                <v-btn v-if="!$user.avatarImage" fab light small v-on="on">
                    <v-icon size="24">person</v-icon>
                </v-btn>

                <v-avatar v-if="$user.avatarImage" color="grey lighten-4" size="40" v-on="on">
                    <img :src="$user.avatarImage" alt="avatar">
                </v-avatar>

            </template>
            <v-list>
                <v-list-tile @click="this.goProfile">
                    <v-list-tile-title>{{$t("Profile")}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="this.logout">
                    <v-list-tile-title>{{$t("Logout")}}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>

    </v-toolbar>
</template>

<script>
    import LocalRepository from '@/repositories/LocalRepository';
    import { VAvatar, VToolbar, VSpacer, VBtn, VChip, VIcon, VMenu, VList, VListTile, VListTileTitle } from 'vuetify/lib'
    import StaminaIndicator from "../../components/StaminaIndicator";

    export default {
        name: 'ToolBar',
        components: {
            StaminaIndicator,
            VToolbar,
            VSpacer,
            VChip,
            VBtn,
            VIcon,
            VMenu,
            VList,
            VAvatar,
            VListTile,
            VListTileTitle
        },
        props: {
            transparent: Boolean,
        },
        data () {
            return {
                // The color of the bar
                color: "white",
                registerAd: false
            }
        },
        created() {
            if (this.transparent) {
                this.color = "transparent";

            }
            this.$root.$on('show-register-ad', () => {
                this.registerAd = true;
            });
        },
        methods: {
            goHome() {
                this.$router.push({name: 'root'});
            },
            goLogin() {
                this.$emit('login');
            },
            goProfile() {
                this.$router.push({name: 'profile'});
            },
            goWeb() {
                window.location = "https://welicense.io/home"
            },
            goReferral(){
                if(this.$user != null){
                    this.$router.push({name: 'referral'});
                }
            },
            goRegister(){
                this.$root.$emit('show-register');
            },
            logout() {
                LocalRepository.clear("token");
                this.$user = null;
                this.$router.push({name: 'home'});
                this.$socket.emit('LOGOUT');
            },
            refer:function() {
                this.$root.$emit('show-modal', {
                    title: this.$t('Refer new users'),
                    message: this.$t('Refer other team members to get 200 free credits'),
                    type: ''
                });
            }
        }
    };
</script>

<style scoped>
    .logo-title {
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
        cursor: pointer;
    }
    @media (min-width: 660px) {
        .largeLogo {
            display: block;
        }
        .smallLogo {
            display: none;
        }
    }

    @media (max-width: 659px) {
        .largeLogo {
            display: none;
        }
        .smallLogo {
            display: block;
        }
    }
</style>